import React from "react";
import Container from "../lib/Container/Container";
import { BorderWrapper, ButtonWithIcon } from "../lib";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useQuery } from "react-query";
import TicketInPersonListTable from "./TicketInPersonListTable";
import { getTicketList } from "../../../api/ticket/ticketApi";
import BackBtn from "../lib/BackBtn";

const TicketInPersonList = () => {

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const pageFromQuery = searchParams.get("page");
  const matchIdFromQuery = searchParams.get("matchId") || "";
  const page = pageFromQuery ? parseInt(pageFromQuery) : 1;
  const [queryString, setQueryString] = React.useState<{
    page: number | string;
    search: string;
    filter: string | number;
    numberInPage: number | string;
    matchId: string | number;
  }>({
    page,
    search: "",
    filter: "",
    numberInPage: 5,
    matchId: matchIdFromQuery,
  });
  const location = useLocation();
  const { state, pathname } = location as any;

  const initialData = state?.data || undefined;
  const { data, isLoading, isError, error, refetch } = useQuery(
    [
      "ticket-list",
      queryString.page,
      queryString.numberInPage,
      queryString.search,
      queryString.matchId,
    ],
    () => getTicketList({ ...queryString })
  );

  //handlers
  const setQSandEnable = (values) => {
    // setEnableQ(()=>true)
    setQueryString(values);
    // refetch();
  };
  const setQS = (page) => {
    //@ts-ignore
    setSearchParams({ page });
    setQueryString((state) => ({
      ...state,
      page: page,
    }));
  };

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error: </div>;

  const goBack = () => {
    navigate({
      pathname: `/ticket-in-person/ticket`,
    });
  };

  return (
    <Container className={"bg-white p-0 mt-10"}>
      {/*Header Start*/}
      <div
        className={
          "d-flex align-items-center justify-content-between table-header"
        }
      >
        <BorderWrapper className={"gap-4"}>
          <div className={"d-flex flex-column"}>
            <span className={"title-m-c"}>خرید بلیت حضوری</span>
            <span>
              <span className={"me-1"}>{data?.totalRows}</span>خرید بلیت حضوری
            </span>
          </div>
          <ButtonWithIcon
            btnText={"افزودن"}
            className={"d-flex gap-3 flex-row-reverse"}
            iconName={"plus-square"}
            iconClassName={"fs-2"}
            onClick={() => navigate("/ticket-in-person/add-ticket")}
          />
        </BorderWrapper>

        <div className={"d-flex align-items-center gap-4"}>
        <BackBtn onClick={() => goBack()} />

          <SearchForm
            onSubmitCallback={(searchTerm) => {
              setQSandEnable({ ...queryString, search: searchTerm });
            }}
            searchTerm={queryString.search}
          />
        </div>
      </div>

      {/*Table Start*/}
      {/*@ts-ignore*/}
      {data?.ticket.length ? (
        <TicketInPersonListTable
          queryString={queryString}
          setQueryString={setQS}
          data={data}
          refetch={refetch}
          numberInPage={queryString.numberInPage}
        />
      ) : (
        <p className={"p-2 m-2"}>فیلدی با این خصوصیات پیدا نشد. </p>
      )}
    </Container>
  );
};

const SearchForm = ({ onSubmitCallback, searchTerm }) => {
  const initialValues = {
    searchTerm: searchTerm || "", // Set initial value from prop if provided
  };

  const onSubmit = (values, { setSubmitting }) => {
    setSubmitting(false);

    // Call the onSubmitCallback if provided
    if (onSubmitCallback && typeof onSubmitCallback === "function") {
      onSubmitCallback(values.searchTerm);
    }
  };

  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {({ isSubmitting, handleChange, values }) => (
        <Form
          className={"d-flex align-items-center gap-3"}
          placeholder={undefined}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        >
          <Field
            type="text"
            name="searchTerm"
            className="border rounded p-2 bg-white w-c-130 text-right"
            placeholder="جستجو"
            onChange={handleChange}
            value={values.searchTerm}
          />
          <ErrorMessage
            name="searchTerm"
            component="div"
            className="text-red-600"
          />
          <ButtonWithIcon
            btnText="جستجو"
            iconName="magnifier"
            type="submit"
            disabled={isSubmitting}
          />
        </Form>
      )}
    </Formik>
  );
};

export default TicketInPersonList;
